module.exports = __webpack_public_path__ + "static/media/star.68c00e0c.svg";